export default "__VITE_ASSET__qMyNH9Rt__"